import {
  AbpApplicationLocalizationService,
  ApplicationLocalizationDto,
  ApplicationLocalizationRequestDto,
} from '@abp/ng.core';
import { inject, Injectable } from '@angular/core';
import { Observable, from, map, switchMap, tap } from 'rxjs';
import { LocalConfigurationRepository } from '../local-db/repositories/local-configuration.repository';
import { ConnectionService } from './connection.service';
import { LocalStorageConsts } from './custom-application-configuration.service';
import { LocalConfigurationType } from '../entities/local-configuration';


@Injectable({
  providedIn: 'root',
})
export class CustomApplicationLocalizationService {
  private readonly _abpApplicationLocalizationService: AbpApplicationLocalizationService;
  private readonly _localConfigurationRepository: LocalConfigurationRepository;
  private readonly serviceProxy: ConnectionService;

  constructor() {
    this._localConfigurationRepository = inject(LocalConfigurationRepository)
    this.serviceProxy = inject(ConnectionService);

    this._abpApplicationLocalizationService = new AbpApplicationLocalizationService();
  }

  get: (options: ApplicationLocalizationRequestDto) => Observable<ApplicationLocalizationDto> = options => {
    const instance = this as CustomApplicationLocalizationService;
    const userFromLocalStorage = localStorage.getItem(LocalStorageConsts.CurrentUserKey);
    const user = userFromLocalStorage ? JSON.parse(userFromLocalStorage) : undefined;

    return instance.serviceProxy.checkOnce().pipe(
      switchMap(isOnline => {
        if (isOnline) {
          return instance._abpApplicationLocalizationService.get(options).pipe(
            tap(response =>
              instance._localConfigurationRepository.set(
                user?.id ?? '',
                LocalConfigurationType.ApplicationLocalization,
                response
              )
            )
          );
        } else {
          return from(
            instance._localConfigurationRepository.get(user?.id ?? '', LocalConfigurationType.ApplicationLocalization)
          ).pipe(map(resp => resp.data as ApplicationLocalizationDto));
        }
      })
    );
  };
}
